import Head from "next/head";
import CallToChaosTablesPage from "../../../../src/tables/s16/CallToChaosTables.tsx";

export default function CallToChaosTablesRoute({ tables }) {
  return (
    <>
      <Head>
        <title>TFT Set 16 Call To Chaos Tables</title>
      </Head>
      <CallToChaosTablesPage tables={tables} />
    </>
  );
}

export async function getStaticProps() {
  // const tablesResp = await fetch(
  //   `https://ap.tft.tools/static/s11/general_odds.json`,
  // );
  // const tables = await tablesResp.json();
  const tables = { loot: [] };

  return {
    props: {
      tables,
    },
    revalidate: 3600,
  };
}
